import { infoCards } from '@/mocks/homeData';

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            编辑力荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            编辑团队严选高分漫画，画风、剧情、口碑三重把关，每一部都值得加入书架
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {infoCards.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex flex-col rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors duration-200"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} - ${item.category}漫画`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).parentElement!.style.display = 'none';
                  }}
                />
                <span
                  className={`absolute top-2 right-2 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    item.status === '连载中'
                      ? 'bg-primary-500/90 text-background-50'
                      : 'bg-secondary-500/90 text-background-50'
                  }`}
                >
                  {item.status}
                </span>
              </div>
              <div className="p-3 md:p-4 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 mb-2">
                  {item.author} · {item.category} · {item.chapters}话
                </p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}